import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StaffProfile } from '@prisma/client';
import { StaffProfileResourceTypeMappings } from '@aa/nest/resource';
import { staffProfileCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class StaffProfileService extends BaseResourceService<StaffProfileResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'staff-profiles');
  }
}
